module.exports = __webpack_public_path__ + "img/tag.080311f4.svg";